import { render, staticRenderFns } from "./cdxUserForm.vue?vue&type=template&id=4307c8be"
import script from "./cdxUserForm.vue?vue&type=script&lang=js"
export * from "./cdxUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports